import {useMemo} from 'react'

import {getInjection} from '@runlab/di'

import type {INotificationService} from '@/src/ports/services/notification'

/**
 * Hook to access INotificationService
 * Provides dependency-injected notification service for UI components
 */
export const useNotification = (): INotificationService => {
  return useMemo(() => getInjection('INotificationService'), [])
}
